import { render, staticRenderFns } from "./DesktopApp.vue?vue&type=template&id=497a9e5e"
import script from "./DesktopApp.vue?vue&type=script&lang=ts"
export * from "./DesktopApp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports